import {
  post_data,
  removeErrorMessage,
  showErrorMessage,
} from "../helpers/functions";

export default function change_password_page() {
  if (window.location.href.indexOf("/change_password") === -1) return;
  const oldPassword = document.querySelector(".old_password");
  const password = document.querySelector(".new_password");
  const confirmPassword = document.querySelector(".repeat_new_password");
  const changePassword = document.getElementById("change_password");
  const container = document.querySelector(".form-container");

  changePassword.addEventListener("click", async () => {
    if (password.value === "" || confirmPassword.value === "") return showErrorMessage("Field can't be empty."); // prettier-ignore
    if (password.value !== confirmPassword.value)  return showErrorMessage("Passwords must match."); // prettier-ignore
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "change_password",
        password: oldPassword.value,
        new_password: password.value,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    if (response.valid === 0 || response === false) return showErrorMessage(response.msg); // prettier-ignore
    container.innerHTML = "";
    const message = document.createElement("p");
    Object.assign(message, {
      className: "input-container text-center",
      textContent:
        "Your password has been successfully changed. You can now sign in with new password.",
    });
    const goBack = document.createElement("a");
    Object.assign(goBack, {
      className: "btn btn-primary w-100 mt-4",
      href: "./projects",
      textContent: "OK",
    });
    container.append(message);
    container.append(goBack);
  });
  password.addEventListener("focus", removeErrorMessage);
  confirmPassword.addEventListener("focus", removeErrorMessage);
}
